import React from 'react';
import styles from "./Ribbon.module.css";

export const Ribbon = ({
    ribbonText,
}: {
    ribbonText: string;
}): React.ReactElement => {

    return (
        <section id="Ribbon">
            <div className={styles.Ribbon}>
                <div className={styles.Text}>
                    {ribbonText}
                </div>
            </div>
        </section>
    );
};
